module.exports = __webpack_public_path__ + "assets/chevron-left.c6f1d7e9.svg";